<template>
  <div class="pos-topbar">
    <div class="bar-left">
      <span class="brand">零售收银台</span>
      <span class="cashier"><a-icon type="user" /> {{ cashierName }}</span>
      <span class="clock">{{ clock }}</span>
    </div>
    <div class="bar-right">
      <span class="net-dot" :class="online ? 'on' : 'off'" :title="online ? '网络正常' : '网络已断开'"></span>
      <div class="tool-pill" @click="$emit('hang')">挂单<span class="key">F2</span></div>
      <div class="tool-pill" @click="$emit('take')">取单<span class="key">F3</span></div>
      <div class="tool-pill" @click="$emit('return')">退货<span class="key">F4</span></div>
      <div class="tool-pill" @click="$emit('shift')">交班<span class="key">F12</span></div>
      <div class="tool-pill" @click="$emit('lock')">锁屏<span class="key">F1</span></div>
      <div class="tool-pill" title="打开顾客副屏（窗口复用，再次点击不重复开）" @click="$emit('screen')">副屏</div>
      <div class="tool-pill" title="独立全屏窗口" @click="openPos">独立窗口</div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  /**
   * 收银台顶部栏：品牌 + 收银员 + 实时时钟 + 工具 pill（挂单/取单/退货/交班/锁屏/独立窗口）+ 网络状态点
   */
  export default {
    name: 'TopBar',
    data() {
      return {
        clock: '',
        timer: null,
        online: navigator.onLine
      }
    },
    computed: {
      ...mapGetters(['userInfo']),
      cashierName() {
        const info = this.userInfo || {}
        return info.username || info.realname || '收银员'
      }
    },
    mounted() {
      this.tick()
      this.timer = setInterval(this.tick, 1000)
      window.addEventListener('online', this.onNet)
      window.addEventListener('offline', this.onNet)
    },
    beforeDestroy() {
      if (this.timer) clearInterval(this.timer)
      window.removeEventListener('online', this.onNet)
      window.removeEventListener('offline', this.onNet)
    },
    methods: {
      tick() {
        const d = new Date()
        const p = n => String(n).padStart(2, '0')
        this.clock = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
      },
      onNet() {
        this.online = navigator.onLine
      },
      openPos() {
        window.open('/pos', '_blank')
      }
    }
  }
</script>

<style scoped>
  .pos-topbar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 8px 14px;
  }
  .bar-left {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .brand {
    font-size: 17px;
    font-weight: 700;
    color: #0081ff;
  }
  .cashier {
    color: #555;
    font-size: 13px;
  }
  .clock {
    color: #999;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
  }
  .bar-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .net-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 4px;
  }
  .net-dot.on {
    background: #52c41a;
  }
  .net-dot.off {
    background: #e4393c;
  }
  .tool-pill {
    border: 1px solid #e8e8e8;
    border-radius: 14px;
    padding: 3px 12px;
    font-size: 13px;
    color: #555;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .tool-pill:hover {
    border-color: #0081ff;
    color: #0081ff;
  }
  .key {
    font-size: 10px;
    color: #bbb;
    border: 1px solid #f0f0f0;
    border-radius: 3px;
    padding: 0 3px;
  }
</style>
